import React, { useState } from 'react';
import { X, Send } from 'lucide-react';

const RequestInfoForm = ({ isOpen, onClose, entityName, entityType }) => {
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
            onClose();
        }, 2500);
    };

    return (
        <div className="form-overlay">
            <div className="form-modal animate-fade">
                <div className="form-header">
                    <h3>Request Information</h3>
                    <button onClick={onClose} className="close-btn"><X size={20} /></button>
                </div>

                {!submitted ? (
                    <form onSubmit={handleSubmit} className="request-form">
                        <p className="form-subtitle">Contact <b>{entityName}</b> regarding their {entityType}.</p>

                        <div className="form-group">
                            <label>Full Name</label>
                            <input
                                type="text"
                                required
                                placeholder="Enter your name"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                required
                                placeholder="your@email.com"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Phone Number</label>
                            <input
                                type="tel"
                                placeholder="+234..."
                                value={formData.phone}
                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Tell us what you need</label>
                            <textarea
                                rows="3"
                                placeholder="Hi, I'm interested in..."
                                value={formData.message}
                                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            ></textarea>
                        </div>

                        <button type="submit" className="primary-btn full-width">
                            <Send size={18} /> Send Inquiry
                        </button>
                    </form>
                ) : (
                    <div className="form-success">
                        <div className="success-icon">✓</div>
                        <h4>Inquiry Sent!</h4>
                        <p>Your request has been forwarded to <b>{entityName}</b>. They will contact you shortly.</p>
                    </div>
                )}
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
        .form-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3000;
          padding: 20px;
        }
        .form-modal {
          background: white;
          width: 100%;
          max-width: 400px;
          border-radius: var(--radius-lg);
          padding: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
        }
        .form-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        .form-subtitle { font-size: 14px; color: var(--text-light); margin-bottom: 20px; }
        .form-group { margin-bottom: 16px; }
        .form-group label { display: block; font-size: 12px; font-weight: 700; color: var(--text-dark); margin-bottom: 6px; text-transform: uppercase; }
        .form-group input, .form-group textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid var(--border-gray);
          border-radius: var(--radius-sm);
          font-family: inherit;
          font-size: 14px;
        }
        .form-group input:focus, .form-group textarea:focus {
          outline: none;
          border-color: var(--primary-green);
          background: var(--light-green);
        }
        .form-success { text-align: center; padding: 20px 0; }
        .success-icon {
          width: 60px;
          height: 60px;
          background: var(--primary-green);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          margin: 0 auto 16px;
        }
      `}} />
        </div>
    );
};

export default RequestInfoForm;
